
function resolveCartItemQuantityStep(item) {
  return 1;
}

function filterCustomerProperties(propertyArray) {
  if (!Array.isArray(propertyArray)) return [];

  return propertyArray.filter(function(property) {
    if (!property || !property.name || property.value == null || property.value === '') {
      return false;
    }

    return property.name.charAt(0) !== '_';
  });
}

if (window.rivets && window.rivets.formatters) {
  window.rivets.formatters.quantity_minus_step = function(item) {
    var step = resolveCartItemQuantityStep(item);
    var quantity = parseInt(item && item.quantity, 10) || 0;

    return Math.max(0, quantity - step);
  };

  window.rivets.formatters.quantity_plus_step = function(item) {
    var step = resolveCartItemQuantityStep(item);
    var quantity = parseInt(item && item.quantity, 10) || 0;

    return quantity + step;
  };

  window.rivets.formatters.customer_properties = function(propertyArray) {
    return filterCustomerProperties(propertyArray);
  };
}

function getAzOnlyProductStatusMap() {
  if (!window._azOnlyProductStatus || typeof window._azOnlyProductStatus !== 'object') {
    window._azOnlyProductStatus = {};
  }

  return window._azOnlyProductStatus;
}

function getAzOnlyLookupMap() {
  if (!window._azOnlyProductLookups || typeof window._azOnlyProductLookups !== 'object') {
    window._azOnlyProductLookups = {};
  }

  return window._azOnlyProductLookups;
}

function getPackSizeMap() {
  if (!window._packSizeByProductId || typeof window._packSizeByProductId !== 'object') {
    window._packSizeByProductId = {};
  }

  return window._packSizeByProductId;
}

function packSizeFromTags(tags) {
  if (!Array.isArray(tags)) return 1;

  for (var index = 0; index < tags.length; index += 1) {
    var match = String(tags[index]).match(/^pack-size\s*:\s*(\d+)$/i);
    if (match && parseInt(match[1], 10) > 1) return parseInt(match[1], 10);
  }

  return 1;
}

function formatPackEquivalence(quantity, packSize) {
  if (!packSize || packSize <= 1) return '';

  var template = window._packEquivalenceTemplate || '__quantity__ × __pack_size__-pack (__burrito_count__ burritos)';
  return template
    .replace('__quantity__', String(quantity))
    .replace('__pack_size__', String(packSize))
    .replace('__burrito_count__', String(quantity * packSize));
}

function syncCheckoutButtonState(button) {
  if (!button) return;

  var postalBlocked = button.dataset.postalBlocked === 'true';
  var azOnlyBlocked = button.dataset.azOnlyBlocked === 'true';
  var isBlocked = postalBlocked || azOnlyBlocked;

  button.classList.toggle('disabled', isBlocked);
  button.setAttribute('aria-disabled', isBlocked ? 'true' : 'false');

  if (isBlocked) {
    button.setAttribute('tabindex', '-1');
  } else {
    button.removeAttribute('tabindex');
  }
}

function setCheckoutPostalBlocked(isBlocked) {
  document.querySelectorAll('.bh-checkout-button').forEach(function(button) {
    button.dataset.postalBlocked = isBlocked ? 'true' : 'false';
    syncCheckoutButtonState(button);
  });
}

function setCheckoutAzOnlyBlocked(isBlocked) {
  var checkoutBtn = document.querySelector('#cart-checkout .bh-checkout-button');
  if (!checkoutBtn) return;

  checkoutBtn.dataset.azOnlyBlocked = isBlocked ? 'true' : 'false';
  syncCheckoutButtonState(checkoutBtn);
}

function isNonArizonaShipping(zipType, savedZip) {
  if (zipType !== 'shipping' || !savedZip) return false;

  var zipPrefix = savedZip.substring(0, 2);
  return zipPrefix !== '85' && zipPrefix !== '86';
}

function getRenderedCartProductIds() {
  var productIds = [];

  document.querySelectorAll('.bh-cart-item[data-product-id]').forEach(function(item) {
    var productId = parseInt(item.dataset.productId, 10);

    if (!isNaN(productId)) {
      productIds.push(productId);
    }
  });

  return productIds;
}

function getAzOnlyRestrictionState() {
  var zipType = localStorage.getItem('bhZipType');
  var savedZip = localStorage.getItem('bhZipCode');

  if (!isNonArizonaShipping(zipType, savedZip)) {
    return { blocked: false, reason: null };
  }

  var statusById = getAzOnlyProductStatusMap();
  var cartProductIds = getRenderedCartProductIds();
  var hasUnknown = false;
  var hasAzOnly = cartProductIds.some(function(productId) {
    var status = statusById[String(productId)];

    if (status === true) return true;
    if (status !== false) hasUnknown = true;
    return false;
  });

  if (hasAzOnly) return { blocked: true, reason: 'az-only' };
  if (hasUnknown) return { blocked: true, reason: 'unknown' };

  return { blocked: false, reason: null };
}

function openSideCart() {
  const sideCart = document.getElementById('bh-side-cart');
  const overlay = document.getElementById('bh-side-cart-overlay');
  
  if (sideCart && overlay) {
    sideCart.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (!window._isRefreshingSideCart) {
      checkAzOnlyRestriction();
    }
  }
}

function closeSideCart() {
  const sideCart = document.getElementById('bh-side-cart');
  const overlay = document.getElementById('bh-side-cart-overlay');
  
  if (sideCart && overlay) {
    sideCart.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function refreshSideCart() {
  window._isRefreshingSideCart = true;

  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Refreshed cart:', cart);
      
      // Update cart counter
      const cartCounter = document.getElementById('counter');
      if (cartCounter) {
        cartCounter.setAttribute('data-count', cart.item_count);
      }
      
      // Update cart items container
      const cartItemsContainer = document.getElementById('cart-items');
      
      if (cart.item_count === 0) {
        cartItemsContainer.classList.add('cart-empty');
        cartItemsContainer.innerHTML = `
          <div>
            <h3>Your cart is empty</h3>
            <a href="/collections/all" class="bh-cta">Shop Burritos</a>
          </div>
        `;
      } else {
        cartItemsContainer.classList.remove('cart-empty');
        
        // Rebuild all cart items HTML
        cartItemsContainer.innerHTML = cart.items.map(item => {
          const imageUrl = item.featured_image ? item.featured_image.url : '';
          const productTitle = item.product_title || '';
          const quantityStep = resolveCartItemQuantityStep(item);
          const packSize = getPackSizeMap()[String(item.product_id)] || 1;
          const packEquivalence = formatPackEquivalence(item.quantity, packSize);
          const decreaseQuantity = Math.max(0, item.quantity - quantityStep);
          const increaseQuantity = item.quantity + quantityStep;

          return `
            <div class="bh-cart-item" data-line-item-key="${item.key}" data-product-id="${item.product_id}">
              <img class="cart-item-thumbnail" src="${imageUrl}" alt="${productTitle}" loading="lazy">
              
              <div class="cart-item-content">
                <a href="${item.url}" class="product-title">${productTitle}</a>
                ${packEquivalence ? `<span class="pack-equivalence">${packEquivalence}</span>` : ''}
                ${window.subscriptionLabel ? `<a style="text-decoration: underline;" href="${item.url}">${window.subscriptionLabel}</a>` : ''}
                <div class="product-quantity-wrapper">
                  <div class="product-quantity">
                    <button class="bh-button" onclick="updateCartQuantity('${item.key}', ${decreaseQuantity})">-</button>
                    <span class="quantity-display">${item.quantity}</span>
                    <button class="bh-button" onclick="updateCartQuantity('${item.key}', ${increaseQuantity})">+</button>
                  </div>
                  <button class="trash-icon" onclick="updateCartQuantity('${item.key}', 0)">
                    ${window.trashIconSVG || ''}
                  </button>
                </div>
              </div>
              
              <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
            </div>
          `;
        }).join('');
      }
      
      // Update subtotal
      const subtotalElement = document.querySelector('#cart-checkout div span:last-child');
      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cart.total_price);
      }

      // T9: keep the east coast estimated total in step with the cart
      window._cartTotalPrice = cart.total_price;
      updateEcShippingSummary();

      // Update discount eligibility flag based on cart contents
      window._cartHasDiscountEligible = cart.items.some(
        item => item.product_type === 'Burritos'
      );

      // Re-evaluate discount bar visibility
      var zipType = localStorage.getItem('bhZipType');
      var cartDiscountBar = document.getElementById('cart-discount-bar');
      if (cartDiscountBar) {
        if (zipType === 'delivery' && window._cartHasDiscountEligible) {
          cartDiscountBar.classList.remove('hidden');
        } else {
          cartDiscountBar.classList.add('hidden');
        }
      }

      // Load product tags for az-only enforcement and pack-size annotations.
      return updateCartProductMetadata(cart).then(function() {
        refreshPackEquivalenceLabels(cart);
        checkAzOnlyRestriction();
        return cart;
      });
    })
    .catch(error => {
      console.error('Error refreshing cart:', error);
    })
    .then(function(result) {
      window._isRefreshingSideCart = false;
      return result;
    });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* =====================================================
   T9: east coast flat-shipping summary (comms §3 rule 9)

   The flat line is only true for east coast carts (west coast
   rates vary by service), so it renders only while the saved
   zip carries a live east coast promise: bhEcMinDelivery
   exists exactly when zipcheck returned the Grip fields, and
   the postal checker clears it on any zip change or dial-down.
   No promise, no saved zip, or dial below 7 -> drawer unchanged.
   ===================================================== */

var BH_EC_FLAT_SHIPPING_CENTS = 1499;

function updateEcShippingSummary() {
  var block = document.getElementById('bh-ec-cart-shipping');
  if (!block) return;

  var totalCents = Number(window._cartTotalPrice) || 0;
  var isEcShipping =
    localStorage.getItem('bhZipType') === 'shipping' &&
    !!localStorage.getItem('bhEcMinDelivery');

  if (!isEcShipping || totalCents <= 0) {
    block.classList.add('hidden');
    return;
  }

  var totalEl = block.querySelector('[data-bh-ec-total]');
  if (totalEl) totalEl.textContent = formatMoney(totalCents + BH_EC_FLAT_SHIPPING_CENTS);
  block.classList.remove('hidden');
}

// Module-level: register cart AJAX handlers once
let _addToCartButton = null;

$(document).ajaxSuccess(function(event, jqxhr, settings) {
  if (settings.url === '/cart/add.js' || settings.url === '/cart/change.js') {
    $(document).one('cart.requestComplete', function(event, cart) {
      console.log(cart);
      refreshSideCart();
      openSideCart();
      if (_addToCartButton) {
        _addToCartButton.classList.remove('loading');
        _addToCartButton = null;
      }
    });
  }
});

$(document).ajaxError(function(event, jqxhr, settings) {
  if (settings.url === '/cart/add.js' || settings.url === '/cart/change.js') {
    if (_addToCartButton) {
      _addToCartButton.classList.remove('loading');
      _addToCartButton = null;
    }
    const errorDescription = jqxhr.responseJSON && jqxhr.responseJSON.description;
    if (errorDescription) {
      alert(errorDescription);
      console.log(errorDescription);
    }
  }
});

function onProductAdd(obj) {
  _addToCartButton = obj;
  obj.classList.add('loading');
}

function updateCartQuantity(lineItemKey, newQuantity) {
  if (newQuantity < 0) return;

  const itemElement = document.querySelector(`[data-line-item-key="${lineItemKey}"]`);

  const itemPriceElement = itemElement.querySelector('.cart-item-price');
  itemPriceElement.classList.add('bh-loader-black');
  itemPriceElement.textContent = '';
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: newQuantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Refresh the side cart to show updated quantities
    refreshSideCart();

    itemPriceElement.classList.remove('bh-loader-black');
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

function updateCartProductMetadata(cart) {
  var statusById = getAzOnlyProductStatusMap();
  var packSizeById = getPackSizeMap();
  var lookupMap = getAzOnlyLookupMap();
  var seenProductIds = {};
  var fetches = [];

  cart.items.forEach(function(item) {
    var productId = String(item.product_id);

    if (seenProductIds[productId]) return;
    seenProductIds[productId] = true;

    if (statusById[productId] !== undefined && packSizeById[productId] !== undefined) return;

    if (!item.handle) {
      statusById[productId] = 'unknown';
      packSizeById[productId] = 1;
      return;
    }

    if (!lookupMap[productId]) {
      lookupMap[productId] = fetch('/products/' + item.handle + '.js')
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to load product metadata');
          }

          return response.json();
        })
        .then(function(product) {
          statusById[productId] = Boolean(product.tags && product.tags.indexOf('az-only') !== -1);
          packSizeById[productId] = packSizeFromTags(product.tags);
        })
        .catch(function(error) {
          console.warn('Unable to confirm az-only tag for cart item', item.handle, error);
          statusById[productId] = 'unknown';
          packSizeById[productId] = 1;
        })
        .then(function() {
          delete lookupMap[productId];
        });
    }

    fetches.push(lookupMap[productId]);
  });

  return Promise.all(fetches);
}

function refreshPackEquivalenceLabels(cart) {
  var packSizeById = getPackSizeMap();

  cart.items.forEach(function(item) {
    var itemElement = document.querySelector('[data-line-item-key="' + CSS.escape(item.key) + '"]');
    if (!itemElement) return;

    var content = itemElement.querySelector('.cart-item-content');
    var title = itemElement.querySelector('.product-title');
    var existing = itemElement.querySelector('.pack-equivalence');
    var label = formatPackEquivalence(item.quantity, packSizeById[String(item.product_id)] || 1);

    if (!label) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('span');
      existing.className = 'pack-equivalence';
      content.insertBefore(existing, title.nextSibling);
    }

    existing.textContent = label;
  });
}

function checkAzOnlyRestriction() {
  var warning = document.querySelector('.bh-az-only-cart-warning');
  var checkoutBtn = document.querySelector('#cart-checkout .bh-checkout-button');
  if (!warning || !checkoutBtn) return;

  var restrictionState = getAzOnlyRestrictionState();

  warning.classList.toggle('hidden', !restrictionState.blocked);
  setCheckoutAzOnlyBlocked(restrictionState.blocked);

  return restrictionState.blocked;
}

function handleCheckout(obj, event) {
  if (event && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }

  if (!obj) return false;

  checkAzOnlyRestriction();
  syncCheckoutButtonState(obj);

  if (
    obj.classList.contains('disabled') ||
    obj.dataset.postalBlocked === 'true' ||
    obj.dataset.azOnlyBlocked === 'true'
  ) {
    return false;
  }

  obj.textContent = '';
  var loader = document.createElement('span');
  loader.className = 'bh-loader';
  obj.appendChild(loader);

  // Method selection and the date/slot picker live in checkout now (BH Scheduling app);
  // the /cart detour only existed so Zapiet's cart-page widget could run.
  window.location.href = '/checkout';
}
